<template>
  <div>
      <section class="xlrclh">
          <img class="top-img" src="./../assets/imgs/139/base.png" alt="" />
          <div class="technological-process">
              <div class="rhtj mar-t2">
                  <img
                      class="top"
                      src="./../assets/imgs/125/desc-title.png"
                      alt=""
                  />
                  <div class="content">
                    成华区紧扣落实成渝地区双城经济圈、成都都市圈、践行新发展理念的公园城市示范区建设等国家和省市区重大部署，以及产业建圈强链等中心任务，深入实施人才强区战略，全面提升人才自主培养质量，培育壮大本土高层次人才队伍，建优建强本土产业领域高端人才队伍，助力建设全国创新人才高地特色区。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/139/title1.png"
                      alt=""
                  />
                  <div class="content">
                    <span>“东骄俊杰”支持范围为在成华区企业、事业单位等用人主体工作5年以上，且个人税收统计均需在成华区的全职在岗人员。项目设置包括存量高端人才团队项目和配套支持项目。</span>
                    <div class="des">
                          <div class="title">一、存量高端人才团队项目</div>
                          <div >
                            主要支持符合成华区产业建圈强链人才需求，经产业链头部企业认定推荐的高管和科研团队。
                          </div>
                      </div>
                      <div class="des">
                          <div class="title">二、配套支持项目</div>
                          <div >
                            主要支持经成华区推荐入选“国家高层次人才特殊支持计划”、四川省“天府青城计划”、成都市“蓉城英才计划”项目的人才。
                          </div>
                      </div>
                  </div>
              </div>
              <div class="zccl" >
                  <img
                      class="top"
                      src="./../assets/imgs/138/title2.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;">
                    在我区年度薪酬总额2000万元以上的企业，可推荐5-10名高管和科研团队，按推荐人选个人年薪总额的5%、最高可享受5万元薪酬奖励；企业通过成华区入选国家和省市重大人才培育计划的，给予最高30万元配套资助。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/138/title3.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;font-weight: bolder;">
                    以当年申报通知为准。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/138/title4.png"
                      alt=""
                  />
                  <div class="content" style="background-color: #fff;font-weight: bolder;">
                    按照每年度通知时间确定。
                  </div>
              </div>
              <div class="contact" style="margin-top: 0.3rem">
                  <img
                      class="top"
                      src="./../assets/imgs/138/title5.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="number">
                          <span class="label">政策咨询电话：</span>
                          <div>
                              <a href="tel:028-84303032">028-84303032</a>
                          </div>
                      </div>
                      <div class="unit">
                          <span class="label">责任单位：</span>
                          成都市成华区委人才办
                      </div>
                  </div>
              </div>
              <!-- <div class="codes">
                  <img class="info" src="../assets/imgs/133/code.png" />
              </div> -->
          </div>
      </section>
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
      return {};
  },

  components: {
      call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;

  .top-img {
      width: 7.26rem;
      height: 5.6rem;
  }

  .technological-process {
      transform: translateY(-1.9rem);

      .rhtj {
          position: relative;

          .top {
              width: 6.86rem;
              height: 2.12rem;
          }

          .content {
              width: 6.85rem;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              background: #ffffff;
              font-size: 0.26rem;
              color: #4e4e4e;
              text-align: left;
              position: relative;
              font-weight: 500;
              line-height: 0.44rem;
          }
      }

      .zccl {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.85rem;
              background: #e8eeff;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              padding-top: 0.28rem;
              font-size: 0.26rem;
              font-weight: 500;
              text-align: left;
              color: #4e4e4e;
              line-height: 0.44rem;

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.35rem 0.23rem 0.3rem;
                  margin-top: 0.8rem;
                  position: relative;
                  text-align: left;

                  .title {
                      position: absolute;
                      top: -0.5rem;
                      left: 50%;
                      transform: translateX(-50%);
                      width: 4.86rem;
                      height: 0.67rem;
                      line-height: 0.67rem;
                      display: flex;
                      justify-content: center;
                      align-content: center;
                      font-size: 0.32rem;
                      font-weight: bold;
                      color: #ffffff;
                      border-radius: 1rem;
                      background-color: #739bfe;
                  }
              }
          }
      }

      .gmlc {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.86rem;
              background: #e8eeff;
              margin: -0.55rem auto;
              padding: 0 0.33rem 0.35rem 0.36rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;

              .circle-box {
                font-size: 0.34rem;
                color: #333;
                font-weight: bold;
                padding-top: 0.5rem;
                text-align: left;
                position: relative;
                .circle {
                  width: 0.28rem;
                  height: 0.28rem;
                  border: 0.06rem solid #FF6D60;
                  border-radius: 50%;
                  flex-shrink: 0;
                  box-sizing: border-box;
                  position: absolute;
                  left: 0;
                  top: 0.62rem;
                  display: inline-block;
                }
                .circle-txt {
                  text-indent: 1.1em;
                }
              }

              .title {
                  font-size: 0.36rem;
                  font-weight: bold;
                  color: #333333;
                  text-align: left;
                  line-height: 0.5rem;
              }

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.3rem 0.23rem;
                  font-size: 0.26rem;
                  font-weight: 500;
                  color: #4e4e4e;
                  line-height: 0.44rem;

                  .line-item {
                      font-size: 0.26rem;
                      position: relative;
                      z-index: 3;

                      .line {
                          position: absolute;
                          width: 0.02rem;
                          height: 130%;
                          border-left: 0.02rem dashed #739bfe;
                          left: 0.2rem;
                          z-index: 0;
                          //   background-color: #739bfe;
                      }

                      .line-title {
                          font-size: 0.3rem;
                          font-weight: bold;
                          color: #3d5aa3;
                      }

                      .line-top {
                          display: flex;
                          width: 4.4rem;
                          height: 0.55rem;
                          background-image: url(../assets/imgs/25/label.png);
                          background-size: 100% 100%;
                          z-index: 99;
                          display: flex;
                          align-items: center;
                          box-sizing: border-box;
                          padding-left: 0.1rem;

                          .line-num {
                              width: 0.44rem;
                              height: 0.44rem;
                              background: #fff;
                              color: #3d5aa3;
                              display: inline-flex;
                              border-radius: 50%;
                              justify-content: center;
                              align-items: center;
                              margin-right: 0.18rem;
                              position: relative;
                              z-index: 3;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              font-size: 0.28rem;
                              font-weight: bold;
                          }
                      }

                      .line-content {
                          //   border-left: 0.02rem dashed #739bfe;
                          padding-bottom: 0.32rem;
                          margin-left: 0.2rem;
                          padding-left: 0.32rem;
                          padding-top: 0.15rem;
                          word-break: break-all;
                          line-height: 0.44rem;
                      }
                  }
              }
          }
      }

      .codes {
          margin: 0 auto;
          margin-top: 0.25rem;
          width: 6.85rem;
          background: #fff;
          padding: 0.3rem;
          box-sizing: border-box;
          border-radius: 0.26rem;
          padding-top: 0.28rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .info {
            width: 100%;
            height: 100%;
          }
      }
  }
}
</style>
